import AssessmentEndingView from './AssessmentEndingView';

export default AssessmentEndingView;